"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeShare = void 0;
var TypeShare;
(function (TypeShare) {
    /**
     * 공유 버튼을 열어요
     * @required url  공유 할 웹 주소
     * @required text 제목
     */
    TypeShare["ReqShareOpen"] = "REQ.SHARE.OPEN";
})(TypeShare = exports.TypeShare || (exports.TypeShare = {}));
//# sourceMappingURL=Share.js.map